import React from "react";
import { Pagination } from "../../../../components/Pagination/pagination.component";
import { BriefListPaginatorProps } from "./brief-list-paginator.props";

export const BriefListPaginator = (props: BriefListPaginatorProps) =>
  props.pageCount > 1 ? <Pagination count={props.pageCount} /> : null;
